import styled from "styled-components";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";

export const TabRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmptyHint = styled.p`
  margin: 0;
  padding: ${spacing[6]} ${spacing[3]};
  text-align: center;
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.lowEmphasis};
`;
